import React from "react";
import "./SlideshowComponentStyles.css"
import { useConfig } from "../../../hooks/ConfigProvider";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import { useTheme } from "../../../hooks/ThemeContext";

type Props = {
    height?: string,
}

const SlideshowComponent = (props: Props) => {
    const { config, isLoading } = useConfig();
    const { restaurantId } = useRestaurant();
    const { theme } = useTheme();

    if (!config || isLoading || !restaurantId) return <></>;

    const restaurant = config?.restaurants?.[restaurantId];
    if (!restaurant) return <></>;

    const image = restaurant.general?.featuredImage || config?.properties?.defaultFeaturedImageUrl;
    if (!image) return <></>;

    return (
        <div
            className="slideshow-container"
            style={{
                width: "100%",
                height: props.height || "35%",
                backgroundColor: theme?.backgroundColor || "#0a1239",
            }}
        >
            <div
                className="slideshow-image"
                style={{ backgroundImage: `url(${image})` }}
            />
            <div className="slideshow-overlay" />
        </div>
    );
}

export default SlideshowComponent;